import { render, staticRenderFns } from "./emailConfig.vue?vue&type=template&id=2399d083&scoped=true"
import script from "./emailConfig.vue?vue&type=script&lang=js"
export * from "./emailConfig.vue?vue&type=script&lang=js"
import style0 from "./emailConfig.vue?vue&type=style&index=0&id=2399d083&prod&lang=scss&scoped=true"
import style1 from "./emailConfig.vue?vue&type=style&index=1&id=2399d083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399d083",
  null
  
)

export default component.exports